export const model = {
    id: null,
    name: '',
    phone_number: 0,
    partner_clinic_id: '',
    created_at: '',
    updated_at: ''
};
